import React from 'react';
import { Link } from 'react-router-dom';
import { useSeo } from '../hooks/useSeo';
import { ArrowRight, Truck, FileSignature, MessageCircle, Phone } from 'lucide-react';
const CARDS = [{
  icon: Truck,
  title: 'Have Your Own Authority?',
  desc: 'Start dispatch and back-office support while running under your own MC.',
  cta: 'Start Dispatch',
  href: 'https://form.jotform.com/260463324672052',
  external: true
}, {
  icon: FileSignature,
  title: 'Looking to Lease On?',
  desc: 'Apply to lease on with FSG for OTR support, dispatch coordination, and a compliance-first setup.',
  cta: 'Apply to Lease On',
  href: 'https://intelliapp.driverapponline.com/c/FSGTransport',
  external: true
}, {
  icon: MessageCircle,
  title: 'Need Trailer Rental or Not Sure?',
  desc: 'Not sure which path fits? Talk to FSG and they will point you in the right direction.',
  cta: 'Talk to FSG',
  href: '/contact',
  external: false
}];
export function ApplyNow() {
  useSeo({
    title: 'Apply or Sign Up With FSG Transport',
    description: 'Choose the FSG Transport path that fits your setup: start dispatch with your own authority, apply to lease on, or talk to FSG about trailer rental and back-office support.',
    path: '/apply-now'
  });
  return <div className="w-full" data-id="element-376">
      <section className="bg-navy text-white pt-36 pb-16 lg:pt-44 lg:pb-20" data-id="element-377">
        <div className="container-custom max-w-3xl" data-id="element-378">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black leading-[1.1] mb-5 tracking-tight font-['Barlow']" data-id="element-379">
            What Kind of Help Do You Need From FSG?
          </h1>
          <p className="text-lg text-off-white/80 font-medium leading-relaxed" data-id="element-380">
            Choose the path that fits your setup. If you are not sure, call FSG
            and they will point you in the right direction.
          </p>
        </div>
      </section>

      <section className="section-padding bg-off-white" data-id="element-381">
        <div className="container-custom grid md:grid-cols-3 gap-6" data-id="element-382">
          {CARDS.map((card, i) => <div key={i} className="bg-white border border-steel rounded-sm p-8 flex flex-col h-full" data-id="element-383">
              <div className="w-12 h-12 bg-navy rounded-sm flex items-center justify-center mb-6" data-id="element-384">
                <card.icon className="w-6 h-6 text-white" data-id="element-385" />
              </div>
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-386">{card.title}</h2>
              <p className="text-body font-medium leading-relaxed mb-8 flex-1" data-id="element-387">
                {card.desc}
              </p>
              {card.external ? <a href={card.href} target="_blank" rel="noopener noreferrer" className="btn-primary w-full inline-flex items-center justify-center gap-2 mt-auto" data-id="element-388">
                  {card.cta}
                  <ArrowRight className="w-4 h-4" data-id="element-389" />
                </a> : <Link to={card.href} className="btn-primary w-full inline-flex items-center justify-center gap-2 mt-auto" data-id="element-390">
                  {card.cta}
                  <ArrowRight className="w-4 h-4" data-id="element-391" />
                </Link>}
            </div>)}
        </div>
        <div className="container-custom mt-12 text-center" data-id="element-392">
          <div className="inline-flex items-center gap-3 bg-white border border-steel px-6 py-4 rounded-sm shadow-sm" data-id="element-393">
            <Phone className="w-5 h-5 text-red" data-id="element-394" />
            <span className="font-bold text-navy text-lg" data-id="element-395">
              Not sure? Call 234-602-8424.
            </span>
          </div>
        </div>
      </section>
    </div>;
}